<div class="grid flex justify-content-center">
  <div class="flex align-items-center justify-content-center">
    <div class="card">
      <h5 class="m-0">{{ settings.title }}</h5>
      <br />
      <p-progressBar
        *ngIf="listingData"
        mode="indeterminate"
        [style]="{ height: '6px' }"
      ></p-progressBar>
      <p-table
        #dt
        [value]="data"
        [columns]="selectedColumns"
        [rows]="10"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        selectionMode="single"
        [rowHover]="true"
        dataKey="id"
        [responsive]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [reorderableColumns]="true"
        styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm"
      >
        <ng-template pTemplate="caption">
          <div
            class="flex md:justify-content-between md:align-items-center mt-2"
          >
            <div class="flex align-items-center justify-content-center">
              <p-multiSelect
                [options]="settings.columns"
                [(ngModel)]="selectedColumns"
                optionLabel="header"
                selectedItemsLabel="{0} columnas seleccionadas"
                [style]="{ width: '100%' }"
                placeholder="Filtrar Columna"
                class="mt-0 mb-2 md:mt-0"
              ></p-multiSelect>
              <span class="block ml-3 mb-2 p-input-icon-left w-24rem">
                <i class="pi pi-search"></i>
                <input
                  style="width: 100%"
                  pInputText
                  type="text"
                  (input)="dt.filterGlobal($event.target.value, 'contains')"
                  placeholder="Buscar..."
                />
              </span>
            </div>
            <div
              class="flex align-items-center justify-content-center ml-6 mb-2"
            >
              <div>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-file-excel"
                  (click)="exportExcel()"
                  class="p-button-success mr-2"
                  pTooltip="XLS"
                  tooltipPosition="bottom"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="pi pi-file-pdf"
                  (click)="exportPdf()"
                  class="p-button-warning mr-2"
                  pTooltip="PDF"
                  tooltipPosition="bottom"
                ></button>
              </div>
              <div>
                <button
                  *ngIf="actions.create"
                  pButton
                  pRipple
                  type="button"
                  (click)="addRow()"
                  class="mr-3 md:mt-0 p-button-rounded p-button-primary"
                  icon="pi pi-plus"
                  pTooltip="Agregar Registro"
                  tooltipPosition="left"
                ></button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th
              *ngFor="let col of selectedColumns"
              pSortableColumn="{{ col.field }}"
            >
              {{ col.header }}
              <p-sortIcon field="{{ col.field }}"></p-sortIcon>
            </th>
            <th *ngIf="onShowColumnAction">Acciones</th>
          </tr>
          <tr>
            <th *ngFor="let col of selectedColumns">
              <input
                id="filterColumn"
                pInputText
                style="width: 100%; max-width: 100%"
                type="text"
                (input)="dt.filter($event.target.value, col.field, 'contains')"
              />
            </th>
            <th *ngIf="onShowColumnAction"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of selectedColumns let i = index" >
              <span class="p-column-title">{{ col.header }}</span>
              <p
                *ngIf="
                  selectedColumns[i].tag !== 'tagStatus' &&
                  selectedColumns[i].tag !== 'tagPaymentMethod'
                "
              >
                {{ rowData[col.field] }}
              </p>

              <p-tag *ngIf="selectedColumns[i].tag === 'tagStatus'"
                     [style]="{'background': rowData['tagStatusColor']}"
                     [severity]="rowData['statusTag']">
                {{rowData[col.field]}}
              </p-tag>
            </td>
            <td *ngIf="onShowColumnAction">
              <div class="flex">
                <button
                  *ngIf="actions.update"
                  pButton
                  pRipple
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success mr-2"
                  (click)="editRow(rowData)"
                  pTooltip="Actualizar Registro"
                  tooltipPosition="left"
                ></button>
                <button
                  *ngIf="actions.delete"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  (click)="deleteRow(rowData)"
                  pTooltip="Eliminar Registro"
                  tooltipPosition="left"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog
  *ngIf="deleteItemDialog"
  [(visible)]="deleteItemDialog"
  header="Confirmar Eliminación"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="flex align-items-center justify-content-center">
    <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"></i>
    <span>¿Está seguro de que desea eliminar el registro seleccionado?</span>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      icon="pi pi-times"
      class="p-button-text"
      label="No"
      (click)="deleteItemDialog = false"
    ></button>
    <button
      pButton
      pRipple
      icon="pi pi-check"
      class="p-button-text"
      label="Si"
      (click)="confirmDeleteSelected()"
    ></button>
  </ng-template>
</p-dialog>
